import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Select as MuiSelect } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import useStyles from "assets/jss/material-dashboard-react/components/customSelectStyle";

const CustomSelect = (props) => {
  const { t } = useTranslation();
  const { label, required, value, options, ...rest } = props;
  const classes = useStyles();

  return (
    <>
      <InputLabel htmlFor={name} className={clsx(classes.label, {})}>
        {t(label)}
        {required ? <span style={{ color: "red" }}> *</span> : null}
      </InputLabel>
      <FormControl variant="outlined" fullWidth size="small">
        <MuiSelect value={value} {...rest} displayEmpty>
          <MenuItem value="">{t("Select ") + t(label)}</MenuItem>
          {options.map((option, index) => (
            <MenuItem key={index} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
    </>
  );
};

CustomSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.array,
  value: PropTypes.string,
};

export default CustomSelect;
